// extracted by mini-css-extract-plugin
export default {"container":"ChangeAtty_container__W5w5y"};